import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import EmailIcon from "@mui/icons-material/Email";
import { start } from "repl";
import useButtonStyles from "../../styles/useButtonStyles";
import ActivityLogNew from "../member/ActivityLogNew";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import ActivityLogDrawerNew from "../member/ActivityLogDrawerNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useAppSelector } from "../../redux/hooks";
import { useParams } from "react-router";
import formatDates from "../../util/dateFormat";
import QRCode from "qrcode.react";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { fontSize, fontWeight } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import NoActivity from "../../assets/NoActivity.png";
import MerchantActivityLog from "./MerchantActivityLog";
import useTableStyles from "../../styles/useTableStyles";
import Loader from "../ui/Loader";
import { filterConstants } from "../../constants/AppConstants";

export type MemberDetailsHeaderNewProps = {
  status?: string;
  merchantId?: string;
  merchant_name?: string;
  promoImage?: string;
};

const MerchantSummaryCard: React.FunctionComponent<
  MemberDetailsHeaderNewProps
> = (props: MemberDetailsHeaderNewProps) => {
  const tableStyle = useTableStyles();
  const { merchantId, merchant_name, promoImage, status } = props;
  const [qrCode, setQrCode] = useState<string>();
  const buttonStyles = useButtonStyles();
  const [openActivityLog, setActivityLog] = useState(false);
  const [openQRzoom, setOpenQRzoom] = useState(false);
  const [logsData, setLogsData] = useState<any>([]);
  const initials = props.merchant_name ? props.merchant_name.split(" ") : "";
  const start = initials[0]?.slice(0, 1).toUpperCase();
  const end = initials[1]?.slice(0, 1).toUpperCase();
  const [loading, setLoading] = useState(false);
  // const entireList = useAppSelector(
  //   (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  // );
  // const external_idForLogs = entireList.find(
  //   (item: any) => item.id === merchantId
  // ).external_id;

  const generateQR = async () => {
    try {
      const qrCode = await axios.get(
        `${
          process.env.REACT_APP_API_URL +
          APIConstants.qrGenerate +
          "?id=" +
          merchantId
        }`
      );
      const qrText = qrCode?.data?.text;
      setQrCode(qrText);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  // getting merchant logs
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL +
          APIConstants.getMemberLogs +
          "?email=" +
          merchantId
        }`
      );
      const mapedData = response.data.result.map((item: any, index: any) => ({
        createdAt: formatDates(item.createdAt),
        activityTitle: item.activity,
        createdBy: item.createdBy ? item.createdBy : "-",
      }));

      mapedData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      setLogsData(mapedData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    generateQR();
  }, []);
  const handlePrint = () => {
    const qrImage: any = document.getElementById("qrCodeDiv");
    if (qrImage) {
      const canvas = qrImage.toDataURL();
      const printContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Document</title>
          <style>
        body {
            margin: 0; /* Remove default margin */
            padding: 0; /* Remove default padding */
            overflow: hidden; /* Prevent horizontal scrollbars */
            display: flex;
            // height : 100%;
            // align-items : center;
            // justify-content : center;
        }
        
        img {
            padding-top:5rem;
            margin:auto;
            width: 50%;
            height: 50%;
            //object-fit: cover; /* Ensure the image covers the entire container */
        }
    </style>
      </head>
      <body>
          <img alt="canvas" src="${canvas}">
      </body>
      </html>
      `;
      const printWindow = window.open("", "", "");
      printWindow?.document.open();
      printWindow?.document.write(printContent);
      // printWindow?.document.close();
      printWindow?.focus();
      setTimeout(() => {
        printWindow?.print();
        printWindow?.close();
        setOpenQRzoom(false);
      }, 100);
    }
  };

  return (
    <Grid
      borderRadius={4}
      // minWidth={"310px"}
      width={"100%"}
      height={"100%"}
      style={{ background: "white" }}
      display={"flex"}
      flexDirection={"column"}
      sx={{ zIndex: 1 }}
      overflow={"hidden"}
    >
      <Dialog
        open={openQRzoom}
        onClose={() => setOpenQRzoom(false)}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
      >
        <DialogContent
          sx={{
            height: "525px",
            width: "525px",
            borderRadius: "16px",
          }}
        >
          <Grid
            p={2}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-evenly"}
            // gap={1}
            minHeight={"30%"}
          >
            <Grid justifyContent={"end"} display={"flex"}>
              <IconButton
                aria-label="delete"
                onClick={() => setOpenQRzoom(false)}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thick,
                fontSize: theme.font?.fontSize.medium,
                textAlign: "center",
                color: theme.color?.newGreyText,
              }}
            >
              Merchant Code
            </Typography>
            <Grid
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              mt={2}
            >
              <QRCode
                id="qrCodeDiv"
                value={merchantId ? merchantId : ""}
                size={264}
              />
              <Button
                onClick={handlePrint}
                sx={{
                  ...buttonStyles.textSecondary,
                  width: "18%",
                  mt: 1,
                }}
              >
                Print QR Code
              </Button>
            </Grid>
            <Grid textAlign={"center"} mt={2}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontWeight: theme.font?.fontWeight.thick,
                  fontSize: theme.font?.fontSize.medium,
                }}
              >
                Unique Code for {merchant_name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontWeight: theme.font?.fontWeight.thick,
                  fontSize: theme.font?.fontSize.medium,
                  color: theme.color?.secondary,
                }}
              >
                {merchantId}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Drawer
        anchor={"right"}
        open={openActivityLog}
        onClose={() => {
          setActivityLog(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"}>
          <Grid
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            px={5}
            py={3}
            sx={{
              position: "sticky",
              top: 0,
              background: theme.color?.background,
            }}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thick,
              }}
            >
              Activity Log
            </Typography>
            <IconButton
              aria-label="delete"
              onClick={() => {
                setActivityLog(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid px={4}>
            <MerchantActivityLog />
          </Grid>
        </Grid>
      </Drawer>
      <Grid
        display={"flex"}
        borderBottom={theme.border?.smallGrey}
        p={2}
        minHeight={"20%"}
      >
        <Grid
          width={"30%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Avatar
            sx={{
              width: 72,
              height: 72,
              background: "#304C89",
              objectFit: "cover",
            }}
            // src={promoImage}
          >
            {start}
            {end}
          </Avatar>
        </Grid>
        <Grid
          width={"70%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-evenly"}
          ml={2}
        >
          <Grid display={"flex"} alignItems={"center"} gap={1}>
            <Typography
              fontSize={theme.font?.fontSize.tableBody}
              sx={{
                textAlign: "center",
                color:
                  status?.toLowerCase() === filterConstants.Active.toLowerCase()
                    ? theme?.color?.success
                    : theme?.color?.error,
                backgroundColor:
                  status?.toLowerCase() === filterConstants.Active.toLowerCase()
                    ? theme?.color?.successLight
                    : theme.color?.errorLight,
                borderRadius: "13px",
                fontFamily: theme.font?.fontFamily.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              minWidth={"40%"}
              maxWidth={"40%"}
            >
              {status}
            </Typography>
          </Grid>
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: theme.font?.fontFamily.primary,
              textTransform: "capitalize",
              fontSize: "3vh",
              wordWrap: "break-word",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {merchant_name}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        p={2}
        borderBottom={theme.border?.smallGrey}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-evenly"}
        minHeight={"40%"}
      >
        <Grid
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          mt={1}
        >
          <Button onClick={() => setOpenQRzoom(true)}>
            <QRCode value={merchantId ? merchantId : ""} size={64} />
          </Button>
          <Button
            onClick={() => {
              setOpenQRzoom(true);
              setTimeout(handlePrint, 500);
            }}
            sx={{
              ...buttonStyles.textSecondary,
              width: "18%",
            }}
          >
            Print QR Code
          </Button>
        </Grid>
        <Grid textAlign={"center"}>
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: theme.font?.fontWeight.thick,
              fontSize: theme.font?.fontSize.medium,
            }}
          >
            {merchant_name} <br></br> Unique Code
          </Typography>
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: theme.font?.fontWeight.thick,
              fontSize: theme.font?.fontSize.medium,
              color: theme.color?.secondary,
            }}
          >
            {merchantId}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        sx={{ padding: "16px 8px" }}
        height={"50%"}
      >
        <Grid display={"flex"} mb={1}>
          <Grid width={"70%"} display={"flex"} alignItems={"center"}>
            <Typography
              textAlign={"left"}
              sx={{
                paddingLeft: 1,
                fontSize: "14px",
                fontWeight: 600,
                color: "#252836",
                fontFamily: theme.font?.fontFamily.primary,
              }}
            >
              Activity Log
            </Typography>
          </Grid>
          <Grid
            width={"30%"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Button
              sx={{
                ...buttonStyles.buttonText,
                color: theme.color?.secondary,
              }}
              onClick={() => {
                setActivityLog(true);
              }}
              disabled={!logsData.length}
            >
              View All
            </Button>
          </Grid>
        </Grid>
        <Grid
          sx={{ overflowY: "auto", height: "220px", ...tableStyle.scrollbar }}
        >
          {loading ? (
            <Grid
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"100%"}
            >
              <Loader />
            </Grid>
          ) : (
            <Grid height={"100%"}>
              {logsData.length ? (
                logsData.slice(0, 5).map((singleLog: any) => {
                  return (
                    <ActivityLogNew
                      title={singleLog.activityTitle}
                      createdAt={singleLog.createdAt}
                      createdBy={singleLog.createdBy}
                    />
                  );
                })
              ) : (
                <Grid
                  height={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <img src={NoActivity} />
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MerchantSummaryCard;
